import * as React from 'react';
import Div from "@jumbo/shared/Div";
import ContentWrapper from 'app/components/ContentWrapper/ContentWrapper';
import ButtonStyled from 'app/components/ButtonStyled/ButtonStyled';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { Typography } from "@mui/material";
import { requestApi } from 'app/utils/RestApi';
import { COMMON } from 'app/utils/constants/endPoint';
import { connect } from 'react-redux';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import TncViewer from 'app/components/TncViewer';
import Checkbox from '@mui/material/Checkbox';
import { removeOtpSession } from '@jumbo/components/JumboAuthProvider/authHelpers';


const MicrositeTnCRegis = (props) => {
	const navigate = useNavigate();
	const [tncData, setTncData] = React.useState("");

	const [userdata, setUser] = React.useState(null);
	const [isChecked, setIsChecked] = React.useState(false);
	const [batchNo, setBatchNo] = React.useState(null);

	React.useEffect(() => {
		document.querySelector("html").classList.add('overflow-hidden');

		if (localStorage.getItem('temp_token')) {
			const ls_user = JSON.parse(localStorage.getItem("userdata"))
			if (ls_user) {
				setUser(ls_user)
			}
		}
	}, []);

	React.useEffect(() => {
		if (userdata) {
			initData()
		}
	}, [userdata]);

	const initData = async () => {
		const res = await requestApi(COMMON.TNC_REFERRER, {
			subfolder: "/" + userdata?.userLoggedin?.referrerCode
		})

		if (res?.data?.data?.tnc) {
			setTncData(res.data.data.tnc)
		}

		if (res?.data?.data?.batchNo) {
			setBatchNo(res.data.data.batchNo)
		}
	}

	const onAgree = async (e) => {
		if (!isChecked) {
			Swal.fire({
				icon: 'warning',
				text: 'Harap setujui Syarat dan Ketentuan terlebih dahulu',
				confirmButtonColor: 'red'
			});
			return;
		}
		
		e.preventDefault();
		await Swal.fire({
			title: 'Apakah anda yakin ingin menyetujui Syarat & Ketentuan ini ?',
			confirmButtonText: 'Ya',
			confirmButtonColor: 'red',
			cancelButtonText: 'Tidak'
		}).then((result) => {
			if (result.isConfirmed) {
				onConfirm()
			}
		})
	};

	const isSubmittingRef = React.useRef(false);

	const onConfirm = async () => {
		if (isSubmittingRef.current) return;

		if (!isChecked) {
			Swal.fire({
				icon: 'warning',
				text: 'Harap setujui Syarat dan Ketentuan terlebih dahulu',
				confirmButtonColor: 'red'
			});
			return;
		}
		
		isSubmittingRef.current = true;
		navigate('/micrositeOtp');
		setTimeout(() => { isSubmittingRef.current = false; }, 1000);
	};

	const onSkip = () => {
		if (userdata?.userLoggedin?.referralStatus === 'REGISTERED') {
			removeOtpSession();
			navigate('/micrositeNews')
		} else {
			backHandler()
		}
	};

	const backHandler = () => {
		removeOtpSession()
		navigate(-1)
	};

	const handleCheckboxChange = (event) => {
		setIsChecked(event.target.checked);
	};

	return (
		<Div className="custompage">
			<ContentWrapper >
				<Div className='content-padding'>
					<Div>
						<Div className='back-icon'>
							<KeyboardBackspaceIcon onClick={backHandler} />
						</Div>
						<Div className='flex-justify-center-title '>
							<Typography fontSize={24} fontWeight={600} color={"#C21B17"}>{(tncData?.title) ? tncData?.title : ""}</Typography>
						</Div>
					</Div>

					<TncViewer content={tncData?.content} batchNo={batchNo} />
					<Div sx={{ mb: 2 }} className='flex-justify-center'>
						<Checkbox
							id="tnc-checkbox"
							checked={isChecked}
							onChange={handleCheckboxChange}
							size='medium'
							sx={{
								'&.MuiButtonBase-root': { padding: 0 },
								'&.Mui-checked': { color: '#C21B17' }
							}}
						/>
						<Typography 
							component="label" 
							htmlFor="tnc-checkbox" 
							fontSize={14} 
							ml={1} 
							sx={{ cursor: 'pointer', userSelect: 'none' }}
						>
							Saya menyetujui Syarat dan Ketentuan dan Kebijakan Privasi yang berlaku. 
						</Typography>
					</Div>


					{/* {(tncAgree) ? ( */}
					<Div className='flex-justify-center' sx={{ mt: 2 }}>
						<ButtonStyled
							onClick={onSkip}
							btnText={"Tidak Setuju"}
							preset={"secondary"}
							sx={{ maxWidth: '451px', mr: 4 }}
						/>
						<ButtonStyled
							onClick={onAgree}
							btnText={"Setuju"}
							preset={"primary"}
							sx={{ maxWidth: '451px' }}
							disabled={!isChecked}
						/>
					</Div>
				</Div>
			</ContentWrapper>
		</Div>

	);
};

const mapStateToProps = state => ({
	authMicrosite: state.authMicrosite
});

export default connect(mapStateToProps)(MicrositeTnCRegis);